import AppSystemResourceModel from '../../generated/types/model/resource/AppSystemResourceModel';

export default class AppSystemResourceViewModel extends AppSystemResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
